module.exports = __webpack_public_path__ + "assets/media/evening.c009375b.mp3";